// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"7f19ea70","787":"6c095dfd"}[chunkId] + ".chunk.js";
};